<!-- Dropdown starts -->
<div *ngIf="!show">
    <section class="mis_dropdown">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="border">
                        <div class="searchwidth">
                            <div class="input-group">
                                <input type="text" class="form-control misinput_control" maxlength="9"
                                    (keypress)="numberOnly($event)" placeholder="Search By Admission No."
                                    [(ngModel)]="academicTerm">
                                <!-- <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let item of Academicdata" [value]="item.admNo"
                                        (click)="selectInput(item)">{{item.name+ ' ' +item.admNo}}</mat-option>
                                </mat-autocomplete> -->

                                <div class="input-group-btn">
                                    <button class="btn drop_iconsearch" type="submit"
                                        (click)="academicsearch(academicTerm)">
                                        <i class="fa fa-search" aria-hidden="true">
                                        </i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Dropdown ends -->
    <!--========== No Date Found =============-->
    <div *ngIf="!selectedStudentData">
        <section class="section_one">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="cctvcouncelling__sec">
                            <div class="councellist__flex">
                                <div class="counceltitle__flex">
                                    <div>
                                        <h5 class="councel__name">Academic Counselling Form</h5>
                                    </div>
                                </div>
                                <div>
                                    <div class="nodata_center">
                                        <figure class="mb-0">
                                            <img src="../../../../assets/image/nodata.png" alt="nodata" class="nodata">
                                        </figure>
                                        <p class="no_data">No Data Found</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <!--==========End No Date Found =============-->
    <!-- ========================= Academic Counselling Form ========================= -->
    <div *ngIf="selectedStudentData">
        <section class="section_one">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="statelist__flex">
                            <div class="ibox-title report_flexweb">
                                <div>
                                    <h5>Academic Counselling Form
                                        <span class="home">Back To Table</span> <i class="fa-solid fa-greater-than"
                                            (click)="togglechildvisibility()"></i>
                                    </h5>
                                </div>
                                <div class="icon_flex">
                                    <input matInput [matDatepicker]="mydate" class="form-control" [value]="startDate" />
                                    <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #mydate></mat-datepicker>
                                </div>
                            </div>
                            <ng-container *ngFor="let item of studentDetails">

                                <div class="cctv_studtl_bg">
                                    <div class="cctv_studtl_grid">
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Student Name</label>
                                                <h6 class="ac_form_text"><mark>{{item.studentName}}</mark></h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Admission Number</label>
                                                <h6 class="ac_form_text">{{item.admNo}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Grade</label>
                                                <h6 class="ac_form_text">{{item.grade}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Exam Program</label>
                                                <h6 class="ac_form_text">{{item.examProgram}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Program Name</label>
                                                <h6 class="ac_form_text">{{item.programName}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">State</label>
                                                <h6 class="ac_form_text">{{item.state}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">City</label>
                                                <h6 class="ac_form_text">{{item.city}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Zone</label>
                                                <h6 class="ac_form_text">{{item.zone}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Campus</label>
                                                <h6 class="ac_form_text">{{item.campus}}</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="form-group">
                                                <label for="" class="cctv_label">Section</label>
                                                <h6 class="ac_form_text">{{item.section}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let item of examDetails">
                                <!-- JEE Advanced -->
                                <div class="ibox-content">
                                    <div class="">
                                        <h5 class="cctv_notes_title">{{item.testMode}}</h5>
                                    </div>
                                    <div>
                                        <ng-container *ngFor="let type of item.testTypeWise">
                                            <label for="exampleFormControlTextarea1"
                                                class="tests_title">{{type.testType}}
                                            </label>
                                            <ng-container>
                                                <div class="table-responsive">
                                                    <table class="table table-borderless academic_table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Subjects</th>
                                                                <ng-container
                                                                    *ngFor="let avg of type.tillAvg[0]?.subjects">

                                                                    <th scope="col"> {{avg.subject}}</th>
                                                                </ng-container>
                                                                <th scope="col">Total</th>
                                                                <th scope="col">Percentage</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="table_rowone_border">
                                                                <td scope="row">Till Avg</td>
                                                                <ng-container
                                                                    *ngFor="let avg of type.tillAvg[0]?.subjects">
                                                                    <td>{{avg.marks}}</td>

                                                                </ng-container>
                                                                <td><strong>{{type.tillAvg[0]?.total}}</strong></td>
                                                                <td>{{type.tillAvg[0]?.percentage}}</td>
                                                            </tr>
                                                            <tr class="table_rowone_border">
                                                                <td scope="row">Last Exam <span class="tooltip_pos">
                                                                        <img src="https://score-cdn-devinfinitylearn.s3.ap-south-1.amazonaws.com/Srichaitanya/academic/forminfo.png"
                                                                            class="forminfo" alt="forminfo">

                                                                        <span
                                                                            class="tooltiptext">{{type.lastExam[0]?.dateOfTest}}</span></span>
                                                                </td>
                                                                <ng-container
                                                                    *ngFor="let last of type.lastExam[0]?.subjects">
                                                                    <td>{{last.marks}}</td>
                                                                </ng-container>
                                                                <td><strong>{{type.lastExam[0]?.total}}</strong>
                                                                </td>
                                                                <td>{{type.lastExam[0]?.percentage}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- Subjects with low performance -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">Subjects with low performance</h5>
                                </div>
                                <div *ngFor="let item of subjectWise; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Subject</label>
                                            <select class="cctv_size" name="subjects{{i}}" id="adminKeytxtId1"
                                                (change)="onSubjectSelect($event,i)"
                                                [(ngModel)]="subjectWise[i].subjectId"
                                                [disabled]="subjectWise[i].isFromServer"
                                                [ngClass]="subjectWise[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Subject</option>
                                                <option *ngFor="let sub of subjectDetails;" value="{{sub.subjectId}}"
                                                    [disabled]="isSubjectDisabled(sub.subjectId)">
                                                    {{sub.subjectName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>
                                            <select class="cctv_size" id="adminKeytxtId" name="faculty_name{{i}}"
                                                (change)="onFacultySelect($event,i)"
                                                [(ngModel)]="subjectWise[i].facultyId"
                                                [disabled]="subjectWise[i].isFromServer"
                                                [ngClass]="subjectWise[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option *ngFor="let fac of subjectWise[i].facultydetails"
                                                    value="{{fac.facultyId}}">
                                                    {{fac.facultyName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="Reason_text{{ i }}" class="form-control "
                                                id="adminValtxtId1" placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]="subjectWise[i].feedback"
                                                [disabled]="subjectWise[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                *ngIf="(subjectWise.length -1)!==i"
                                                (click)="deleteLowPerformanceFields(i,'Disabled')">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                *ngIf="(subjectWise.length -1)==i" (click)="addLowPermanceFields()"
                                                [disabled]="isRowEmpty(i)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Subject wise difficulties for student -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">Subject wise difficulties for student</h5>
                                </div>
                                <div *ngFor="let item of subjectdifficulties; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Subject</label>
                                            <select class="cctv_size" id="adminKeytxtId" name="subject{{i}}"
                                                (change)="onSubjectSelectdifficulties($event,i)"
                                                [(ngModel)]="subjectdifficulties[i].subjectId"
                                                [disabled]="subjectdifficulties[i].isFromServer" 
                                                [ngClass]="subjectdifficulties[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden >Select Subject</option>
                                                <option *ngFor="let subdiff of subjectDetails;"
                                                    value="{{subdiff.subjectId}}"
                                                    [disabled]="issubjectDisabledDiff(subdiff.subjectId)">
                                                    {{subdiff.subjectName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>
                                            <select class="cctv_size" id="adminKeytxtId" name="faculty_names{{i}}"
                                                (change)="onFacultySelectdiff($event,i)"
                                                [(ngModel)]="subjectdifficulties[i].facultyId"
                                                [disabled]="subjectdifficulties[i].isFromServer"
                                                [ngClass]="subjectdifficulties[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option
                                                    *ngFor="let difffac of subjectdifficulties[i].difficultyfacultydetails"
                                                    value="{{difffac.facultyId}}">
                                                    {{difffac.facultyName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="Reason_texts{{ i }}" class="form-control "
                                                id="adminValtxtId1" placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]='subjectdifficulties[i].feedback'
                                                [disabled]="subjectdifficulties[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                *ngIf="(subjectdifficulties.length -1)!==i"
                                                (click)="deletesubjectwisedifficulties(i)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                *ngIf="(subjectdifficulties.length -1)==i"
                                                (click)="addsubjectwisedifficulties()" [disabled]="isDiffRowEmpty(i)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Reason for low performance -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">Reason for low performance</h5>
                                </div>
                                <div *ngFor="let item of subjectwisereason; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Subject</label>
                                            <select class="cctv_size" id="adminKeytxtId1"
                                                (change)="onSubjectSelectreasons($event,i)"
                                                [(ngModel)]="subjectwisereason[i].subjectId"
                                                [disabled]="subjectwisereason[i].isFromServer" 
                                                [ngClass]="subjectwisereason[i].isFromServer?'readbackground':''" >
                                                <option value=""  selected disabled hidden>Select Subject</option>
                                                <option *ngFor="let subreason of subjectDetails;"
                                                    value="{{subreason.subjectId}}"
                                                    [disabled]="issubjectDisabledreasons(subreason.subjectId)">
                                                    {{subreason.subjectName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>
                                            <!-- <input type="text" value="" class="form-control" placeholder="Faculty Name"
                                            id="adminKeytxtId1"> -->
                                            <select class="cctv_size" id="adminKeytxtId" name="faculty_names{{i}}"
                                                (change)="onFacultySelectreasons($event,i)"
                                                [(ngModel)]="subjectwisereason[i].facultyId"
                                                [disabled]="subjectwisereason[i].isFromServer"
                                                [ngClass]="subjectwisereason[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option
                                                    *ngFor="let reasonfac of subjectwisereason[i].reasonfacultydetails"
                                                    value="{{reasonfac.facultyId}}">
                                                    {{reasonfac.facultyName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="" class="form-control " id="adminValtxtId1"
                                                placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]="subjectwisereason[i].feedback"
                                                [disabled]="subjectwisereason[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                *ngIf="(subjectwisereason.length -1)!==i"
                                                (click)="deletesubjectwisereasons(i)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                *ngIf="(subjectwisereason.length -1)==i"
                                                (click)="addsubjectwisereasons()" [disabled]="isreasonRowEmpty(i)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- Observations by -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">Observations by</h5>
                                </div>
                                <div *ngFor="let item of observationswise; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Observations by</label>
                                            <select class="cctv_size " id="adminKeytxtId1"
                                                (change)="onSubjectSelectobservation($event,i)"
                                                [(ngModel)]="observationswise[i].designationId"
                                                [disabled]="observationswise[i].isFromServer"
                                                [ngClass]="observationswise[i].isFromServer ?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Designation</option>
                                                <option *ngFor="let iteam of designationDetails"
                                                    value="{{iteam.designationId}}">
                                                    {{iteam.designationName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>

                                            <select class="cctv_size" id="adminKeytxtId" name="faculty_names{{i}}"
                                                (change)="onFacultySelectobservation($event,i)"
                                                [(ngModel)]="observationswise[i].facultyId"
                                                [disabled]="observationswise[i].isFromServer"
                                                [ngClass]="observationswise[i].isFromServer?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option
                                                    *ngFor="let obserfac of observationswise[i].observationfacultydetails"
                                                    value="{{obserfac.facultyId}}"
                                                    [disabled]="issubjectDisabledobservation(obserfac.facultyId)">
                                                    {{obserfac.facultyName}}</option>
                                            </select>

                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="" class="form-control " id="adminValtxtId1"
                                                placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]="observationswise[i].feedback"
                                                [disabled]="observationswise[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                (click)="deleteobservation(i)" *ngIf="(observationswise.length -1)!==i">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                [disabled]="isobservationRowEmpty(i)" (click)="addobservation()"
                                                *ngIf="(observationswise.length -1)==i">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="addplus">

                                    </div>
                                </div>
                            </div>
                            <!-- Suggestions by -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">Suggestions by</h5>
                                </div>
                                <div *ngFor="let item of suggestionswise; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Suggestions by</label>
                                            <select class="cctv_size " id="adminKeytxtId1"
                                                (change)="onSubjectSelectsuggestion($event,i)"
                                                [(ngModel)]="suggestionswise[i].designationId"
                                                [disabled]="suggestionswise[i].isFromServer"
                                                [ngClass]="suggestionswise[i].isFromServer ?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Designation</option>
                                                <option *ngFor="let item of designationDetails"
                                                    value="{{item.designationId}}">{{item.designationName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>

                                            <select class="cctv_size " id="adminKeytxtId1"
                                                (change)="onFacultySelectsuggestion($event,i)"
                                                [(ngModel)]="suggestionswise[i].facultyId"
                                                [disabled]="suggestionswise[i].isFromServer"
                                                [ngClass]="suggestionswise[i].isFromServer ?'readbackground':''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option
                                                    *ngFor="let suggfac of suggestionswise[i].suggestionfacultydetails"
                                                    value="{{suggfac.facultyId}}"
                                                    [disabled]="issubjectDisabledsuggestion(suggfac.facultyId)">
                                                    {{suggfac.facultyName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="" class="form-control " id="adminValtxtId1"
                                                placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]="suggestionswise[i].feedback"
                                                [disabled]="suggestionswise[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                *ngIf="(suggestionswise.length -1)!==i" (click)="deletesuggestions(i)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                *ngIf="(suggestionswise.length -1)==i"
                                                [disabled]="issuggestionRowEmpty(i)" (click)="addsuggestions()">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="addplus">

                                    </div>
                                </div>

                                <div class="">
                                    <form [formGroup]="myform">
                                        <div class="form-group">
                                            <label for="exampleFormControlTextarea1" class="cctv_label">Target and
                                                action
                                                plan
                                                for
                                                the next week test</label>
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="2"
                                                formControlName="target" [(ngModel)]="tagetPlan"></textarea>

                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- What is the support required by? -->
                            <div class="ibox-content">
                                <div class="">
                                    <h5 class="cctv_notes_title">support required by</h5>
                                </div>
                                <div *ngFor="let item of supportwise; let i=index">
                                    <div class="add_grid" *ngIf="item.feedbackStatus != 'Disabled'">
                                        <div class="grid_one">
                                            <label for="" class="cctv_label" *ngIf="i==0">Require by</label>
                                            <select class="cctv_size" id="adminKeytxtId1"
                                                (change)="onSubjectSelectsupport($event,i)"
                                                [(ngModel)]="supportwise[i].designationId"
                                                [disabled]="supportwise[i].isFromServer"
                                                [ngClass]="supportwise[i].isFromServer? 'readbackground' : ''">
                                                <option value=""  selected disabled hidden>Select Designation</option>
                                                <option *ngFor="let dsn of designationDetails"
                                                    value="{{dsn.designationId}}">
                                                    {{dsn.designationName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_two">
                                            <label for="" class="cctv_label" *ngIf="i==0">Faculty Name</label>
                                            <!-- <input type="text" value="" class="form-control" placeholder="Faculty Name"
                                            id="adminKeytxtId1" readonly> -->
                                            <select class="cctv_size " id="adminKeytxtId1"
                                                (change)="onFacultySelectsupport($event,i)"
                                                [(ngModel)]="supportwise[i].facultyId"
                                                [disabled]="supportwise[i].isFromServer"
                                                [ngClass]="supportwise[i].isFromServer? 'readbackground' : ''">
                                                <option value=""  selected disabled hidden>Select Faculty</option>
                                                <option *ngFor="let supfac of this.supportwise[i].supportfacultydetails"
                                                    value="{{supfac.facultyId}}"
                                                    [disabled]="issubjectDisabledsupport(supfac.facultyId)">
                                                    {{supfac.facultyName}}</option>
                                            </select>
                                        </div>
                                        <div class="grid_three">
                                            <label for="" class="cctv_label" *ngIf="i==0">Reason</label>
                                            <textarea name="" class="form-control " id="adminValtxtId1"
                                                placeholder="Reason" cols="30" rows="3"
                                                [(ngModel)]="supportwise[i].feedback"
                                                [disabled]="supportwise[i].isFromServer"></textarea>
                                        </div>
                                        <div class="grid_four">
                                            <h5>&nbsp;</h5>
                                            <button type="button" class="btn_delete text-danger remove_field"
                                                *ngIf="(supportwise.length -1)!==i" (click)="deletesupport(i)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="add_btn add_field_button"
                                                *ngIf="(supportwise.length -1)==i" (click)="addsupport()"
                                                [disabled]="issupportRowEmpty(i)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="addplus">

                                    </div>
                                </div>
                            </div>
                            <div class="ibox-content bt-1">
                                <div class="col-lg-12 text-center">
                                    <div class="bottombtnflex" *ngIf="!isSubmittedForm">
                                        <div>
                                            <button type="button" (click)="save()" class="savedraft_btn"
                                                [disabled]="isSubmittedForm">Save as
                                                Draft</button>
                                        </div>
                                        <div>
                                            <button type="submit" class="cctv_notebtn" (click)="submit()"
                                                [disabled]="isSubmittedForm">Final
                                                Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    </div>
</div>
<!-- ========================= section end ========================= -->

<!------------- save to click navigate parent to child component ----------->
<div *ngIf="show">
    <app-academic-students-table (academicback)="onacademicShow($event)"
        (tablebackData)="onTableDataShow($event)"></app-academic-students-table>
</div>

<!--  -->

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>